import React from 'react';

export default class Div extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const pr = this.props;

        return (
            <img {...pr}>
                {pr.children}
            </img>
        );
    }

    styles = {
    };
}
